import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { getUrlPathWithSuffix, pathNames, variablePathNames } from '../../utilities/routing-path-utils';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentPlan } from '../../models/enums/payment-plan';
import { UserService } from '../../services/user.service';
import { NgIf } from '@angular/common';
import { localStoragevarNames } from '../../utilities/local-storage-utils';
import { AppComponentEventsService } from '../../events/app-component-events.service';
import { resetUserInLocalStorage } from '../../utilities/user-utils';

@Component({
  selector: 'app-payment-success-page',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    NgIf
  ],
  templateUrl: './payment-success-page.component.html',
  styleUrl: './payment-success-page.component.scss'
})
export class PaymentSuccessPageComponent {
  aiAgentsPath: string = getUrlPathWithSuffix(pathNames.aiAgentConfigurationPath);
  paymentPlan!: PaymentPlan;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private appComponentEventService: AppComponentEventsService,
  ) { }

  ngOnInit() {
    this.initPaymentPlan();
    this.fetchLoggedUserThenStoreInLocalStorage();
  }

  onSeeAgentsClicked() {
    this.router.navigate([this.aiAgentsPath]);
  }

  fetchLoggedUserThenStoreInLocalStorage() {
    this.userService.fetchLoggedUser().subscribe({
      next: user => {
        resetUserInLocalStorage(user);
        this.appComponentEventService.onNavRefreshEvent.emit();
      },
      error: () => {
        alert('Server error contact support');
      }
    });
  }

  initPaymentPlan() {
    this.route.paramMap.subscribe(params => {
      const paymentPlan = params.get(variablePathNames.paymentPlanPathVariable)!;
      this.paymentPlan = PaymentPlan[paymentPlan as PaymentPlan];
    });
  }
}
